class LoginController {
    /*@ngInject*/
    constructor ($mdDialog, $scope, $stateParams, $state, orderStore, auth, utils) {
        "ngInject";
        _.extend(this, {
            $scope: $scope,
            $stateParams: $stateParams,
            $state: $state,
            orderStore: orderStore,
            auth: auth,
            utils: utils,
            $mdDialog: $mdDialog
        });
        this.customer = {};
        this.loader = this.auth.isAdminUser() ? this.getOrderLoader() : {};
    }

    enterKey(keyEvent) {
        if (keyEvent.which == 13 || keyEvent.keyCode == 13) {
            this.requestTPin();
        }
    }
    getOrderLoader() {
        return this.orderStore.getOrder(this.$stateParams.orderId)
            .then(
                (order) => {
                    this.order = order;
                    this.flatOrderItems = this.utils.flattenOrderItems(this.order.order_items, this.order.item_stats, this.order.vehicle_statistics, this.order.property_type);
                    this.itemsVolume = _(this.flatOrderItems)
                        .filter((item) => _.isUndefined(item._destroy))
                        .sum('cubic_feet')
                },
                (error) => this.$q.reject(error)
            );
    }
    requestTPin() {
        const isValidForm = this.checkIfValidForm();
        if (!isValidForm) {
            return false;
        }

        this.loader = this.auth.createUser(this.customer)
            .then(
                (user) => this.next(user),
                (error) => this.utils.showErrorPopup('Login Failed!', 'Login Failed!', error.message)
            );
    }

    checkIfValidForm() {
        const form = this.contactForm;

        // Set form as submitted
        form.$setSubmitted();

        return form.$valid;
    }

    next(user) {
        if (this.auth.isAdminUser()) {
            const specifiedRedirect = this.$stateParams.redirect;

            this.order.user_id = user.id;
            return this.orderStore.saveOrder(this.order)
                .then(
                    (order) => {
                        /**
                         * If someone wants us to redirect elsewhere than the quotes page
                         *  after verifying contact details,
                         *  obey the directive
                         */
                        if (specifiedRedirect) {
                            return this.$state.go(specifiedRedirect, {orderId: order.id});
                        }

                        let [moveType, propertyType] = [order.move_type, order.property_type],
                            quotePage = this.utils.getQuotePageForOrderWith(moveType, propertyType);

                        let nextState = this.utils.getAdminStateIfApplicable(quotePage);
                        return this.$state.go(nextState, {orderId: order.id});
                    },
                    (error) => {
                        console.log(error);
                        return error;
                    }
                );
        }

        this.$state.go('base.tpin', {orderId: this.$stateParams.orderId, redirect: this.$stateParams.redirect, showSavePopup: this.$stateParams.showSavePopup});
    }

    tcPopup() {

        let popupController = function popupController($scope, $mdDialog) {
            $scope.ok = function() {
                $mdDialog.hide();
            }
        }

        this.$mdDialog.show({
            controller: popupController,
            template: require('common/popup.component/contactDetailsPopup.html'),
            parent: angular.element(document.body),
            clickOutsideToClose: true
        });

        popupController.$inject = ['$scope', '$mdDialog']; //to enable proper dependency injection during js minification

    }
}


export default LoginController;


// WEBPACK FOOTER //
// ./client/app/components/login/login.controller.js